const RootPath = window.g.baseUrl
const apis = {
  /* 产品 api */
  // 获取产品类别列表
  getProductCategories: RootPath + 'plugin/product/category/index',
  // 获取单个产品类别
  getProductCategory: RootPath + 'plugin/product/category/getForm',
  // 保存产品类别
  saveProductCategory: RootPath + 'plugin/product/category/save',
  // 删除产品类别
  delProductCategories: RootPath + 'plugin/product/category/delBatches',

  // 根据产品类别ID获取产品列表
  getProducts: RootPath + 'plugin/product/default/index',
  // 获取单独产品
  getProduct: RootPath + 'plugin/product/default/getForm',
  // 保存产品
  saveProduct: RootPath + 'plugin/product/default/save',
  // 删除产品
  delProducts: RootPath + 'plugin/product/default/delBatches',
  // 获取部品，供批量选择
  getProductParts: RootPath + 'plugin/product/default/getProductParts',
  // 获取产品汇总
  getProductSum: RootPath + 'plugin/product/default/GetProductSum',
  // 根据选择行获取原材料出入库数据
  getProductStores: RootPath + 'plugin/product/default/GetProductStores'

}

export default apis
